import React from "react";
import Card from "@material-tailwind/react/Card";
import CardImage from "@material-tailwind/react/CardImage";
import CardBody from "@material-tailwind/react/CardBody";
import CardFooter from "@material-tailwind/react/CardFooter";
import H6 from "@material-tailwind/react/Heading6";
import '../CSS/userDashboard.css'
import {useStateValue} from '../StateProvider'
import { CounsellorsData }  from './Data/CounsellorsData';
import { Link } from 'react-router-dom'
import NavOnlyIcons from "./NavOnlyIcons";
import SubFooter from "./SubFooter";

const UserDashboard = () => {

    const [{user}] = useStateValue();

    return (
    
    <>
        <div className="userDashboard">
            <div className="navDiv" id='userDashboardNav'>
                <NavOnlyIcons /> 
            </div>
            <div className="rightDivUser">
                <div className="rightUserDivTop">
                    <div className="rightDivUserText">
                        <h2>Hey, we can help! Share with us what you feel</h2>
                        <small>Conversation with right person may sooths your mind
                        Talk to our qualified counsellors and therapists via chat, voice or video Call.</small>
                    </div>

                    <div className="rightDivUserImg">
                    
                    </div>
                </div>
                <div className="userDashBoardCounsellors">
                    <div className="Counsellors_profile">
                    {
                        CounsellorsData.map(data => (
                            <div className='cards_div' id='counsellorCardDiv'>
                                <Card className='card'>
                                    <div className="cardCounsellorDetails">
                                        <div className="cardImageDiv">
                                            <CardImage  id='counsImg' src={data.imgURL} alt="Card"/>
                                        </div>
                                        <div className="cardDetailsCons">
                                            <CardBody id='cardBody'>
                                                <H6 className="Counsellor_Name" color="gray">{data.name}</H6>
                                                <h2 className="Counsellor_Study"color="gray"><i className="fas fa-briefcase"></i>{data.study}</h2>
                                                <h2 className="Counsellor_exp"color="gray"><i className="fas fa-building"></i>{data.exp}</h2>
                                                <h2 className="Counsellor_qual"><i className="fas fa-portrait"></i>{data.qual}</h2>
                                            </CardBody>

                                            <div className="counsellorLinks" id='counsellorLinks'>
                                                <Link id='availLink' to='/'>
                                                    <i className="fas fa-caret-right"></i>
                                                    Availability
                                                </Link>
                                                <Link id='aboutLink' to='/aboutCounsellor'>
                                                    <i className="fas fa-caret-right"></i>
                                                    About
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <CardFooter className='card_footerCounsellor'>
                                        <Link to={user ? ('/select_mode') : ('login_Signup')}>
                                            <button>Book a Session</button>
                                        </Link>
                                    </CardFooter>
                                </Card>
                            </div>
                        ))
                    }
                    
                </div>
                
            </div>
        </div>                                         
    </div>
    <SubFooter />   
    </>
    )
}

export default UserDashboard
